module.exports = __webpack_public_path__ + "files/91f899503c98885194b46831779298a6.png";